import React from 'react';
import {Typography, Box, Theme, Rating} from '@mui/material';
import Strings from "../assets/strings";

import {formatPeso} from "../helpers";
import DefaultImgEmp from '../assets/img/defaultAvatar_empresa.jpg';
import NoImg from '../assets/img/defaultAvatar.jpg';
import {ICliente} from "../redux/types/ICliente";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme:Theme) => ({
    root: {
        cursor:"pointer",
        border: "1px solid #ddd",
        background: "#fff",
        textAlign: "center",
        padding: 20,
        position: "relative",
        [theme.breakpoints.down('md')]: {
            padding: "10px 15px",
            textAlign: "left",
            border: "none",
            borderBottom: "1px solid #f1f1f1"
        },
        "& .moreVertIcon":{
            position: "absolute",
            top: 5,
            right: 5,
            width: 27,
            height: 27,
        }
    },
    imgCont:{
        width: 100,
        height: 100,
        marginBottom:8,
        margin: "0 auto",
        position: "relative",
        [theme.breakpoints.down('md')]: {
            float:"left",
            width:50,
            height:50,
            marginRight: 12
        },
    },
    imgCircle: {
        borderRadius: "50%",
        width:"100%",
        height:"100%",

    },
    status:{
        display: "block",
        width: 12,
        height: 12,
        background: "gray",
        border: "3px solid #fff",
        borderRadius: "50%",
        position: "absolute",
        right: 5,
        bottom: 5,
        "&.e0":{
            background: "red"
        },
        "&.e1":{
            background: "#01a855"
        },
        "&.e2":{
            background: "orange"
        }
    }
}));



export default function ClientCard({ cliente,onClick }:{ cliente:ICliente,onClick:()=>void }) {
    const classes = useStyles();

    return (
        <div className={classes.root} onClick={()=>onClick()}>
            <div className={classes.imgCont} >
                <img alt="avatar" src={ cliente.avatar?cliente.avatar: (cliente.tipo === 2 ?DefaultImgEmp: NoImg)}
                     loading={"lazy"}
                     className={classes.imgCircle} />
                <span className={classes.status +" e"+ cliente.estado} ></span>
            </div>
            <div>
                <Typography variant="subtitle1" noWrap={true}>
                    {cliente.nombres +" "+cliente.apellidos}
                </Typography>
                <Box display={"flex"} alignItems="center" justifyContent={"center"} mb={1}>
                    <Rating value={cliente.calificacion || 0} precision={0.5} size="small" readOnly /> &nbsp;
                    <Typography variant={"caption"} lineHeight={0}>{cliente.calificacion}</Typography>
                </Box>
                <Box display={"flex"} justifyContent="space-around" fontSize=".8rem">
                    <Box>{Strings.capital}: {formatPeso(cliente.capitalPendiente)}</Box>
                    <Box>{Strings.balance}: {formatPeso(cliente.balancePendiente)}</Box>
                </Box>
            </div>
        </div>

    )
}
